module.exports = __webpack_public_path__ + "img/banner1.a5f83cd1.png";